import { graphql } from 'react-apollo';

import { AlbumForWebGalleriesFolder } from '../../../../../../pro/views/HierarchyItem/Matches/graphql/queries/album';

const AlbumForWebGalleriesFolderOptions = {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumMembershipGroupId,
    },
    fetchPolicy: 'network-only',
  }),
  skip: ({ match }) => !match.params.albumMembershipGroupId,
};

const getAlbumForWebGalleriesFolder = graphql(
  AlbumForWebGalleriesFolder,
  AlbumForWebGalleriesFolderOptions,
);

export default getAlbumForWebGalleriesFolder;
